import { useCallback, useState } from "react";
import { detectCurrency, saveCurrency } from "../Services/paymentService";

// The buyer's payment currency ("NGN" | "USD"): detected once, then switchable.
export default function usePaymentCurrency() {
  const [currency, setCurrency] = useState(detectCurrency);
  const choose = useCallback((next) => {
    saveCurrency(next);
    setCurrency(next);
  }, []);
  return [currency, choose];
}
